export default __webpack_public_path__ + "static/media/litho-landing-page-blog-01.a3c5a943.jpg";